<template>
  <gw-entity-filter-item
    class="a7-visao-filter-item"
    :display-text="displayText"
    :property-name="propertyName"
    representation-field="nome"
    :search="finderVisao"
    :minimum-pattern-length="1"
    :find-values="finderVisaoByIDs"
    :selection-support="A7VisaoListing"
    >
    <div slot="item" slot-scope="{entity}">
      <b>{{$t('Visao.ui.filterItem.nome')}} </b>{{entity.nome}}<br/>
    </div>
  </gw-entity-filter-item>
</template>

<script>
import { GwEntityFilterItem, GwCustomFilterItemMixin } from 'guaxinim-web'
import VisaoRestResource from './VisaoRestResource'
import A7VisaoListing from './A7VisaoListing'
export default {
  name: 'a7-visao-filter-item',
  mixins: [GwCustomFilterItemMixin],
  components: {
    GwEntityFilterItem
  },
  data(){
    return {
      A7VisaoListing: A7VisaoListing
    }
  },
  methods: {
    finderVisao(pattern) {
      if (!pattern) return null
      return VisaoRestResource.findVisaoFinderDTO(pattern, 10)
    },
    finderVisaoByIDs(ids) {
      return VisaoRestResource.findEntities(ids)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
